<template>
  <div class="row">
    <div class="col-xs-12">
      <i
        v-if="!saved"
        class="af-icons af-icons-repeat af-icons-animate-rotate mtx"
      ></i>
      <div v-if="saved && success">
        <h2>
          {{ lang.get('judging.fast_start.complete.title') }}
        </h2>
        <p>
          {{ lang.get('judging.fast_start.complete.configuration_complete') }}
        </p>
        <p>
          {{ lang.get('judging.fast_start.complete.note') }}
        </p>
        <p v-if="userAddedToPanel && redirect">
          <a :href="redirect">
            {{ lang.get('judging.fast_start.complete.configuration_test') }}
          </a>
        </p>
        <a
          :href="route(routes['judging-dashboard.index'])"
          class="btn btn-primary"
        >
          {{ lang.get('judging.fast_start.complete.judging_dashboard') }}
        </a>
      </div>
      <div v-if="saved && !success">
        <h2>
          {{ lang.get('judging.fast_start.complete.error') }}
        </h2>
        <p>
          {{ lang.get('judging.fast_start.complete.configuration_failure') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { route } from '@/lib/utils.js';

export default {
  inject: ['lang'],
  props: {
    routes: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      saved: false,
      success: false,
      redirect: null
    };
  },
  computed: {
    ...mapGetters('judgingFastStart', ['data', 'panel']),
    userAddedToPanel() {
      return this.panel && this.panel.addMyself;
    }
  },
  created() {
    this.$http.post(route(this.routes['fast-start.save']), this.data).then(
      response => {
        this.saved = true;
        this.success = true;
        this.redirect = response.data.redirect;
      },
      () => {
        this.saved = true;
        this.success = false;
      }
    );

    this.$emit('finish');
  },
  methods: {
    route
  }
};
</script>
